export default __webpack_public_path__ + "static/media/QewdLogoLogin.495a1d4b.svg";